import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ExitToApp from '@material-ui/icons/ExitToApp';
import LogoRender from './LogoRender';

export default class SignInStatusPanel extends Component {

    render() {
        return (
            <Paper 
                elevation={1}
                style={{
                    padding:10,
                    // minWidth: 300,
                    // display:'inline-block'
                }}>
                
                {this.props.signed_in&&
                <Grid 
                    container
                    direction='row'
                    alignItems='center'
                    justifyContent='center'
                >

                    <Typography style={{textAlign:'left'}}>
                        {this.props.employee_name}
                        {/* <b>{this.props.user.displayName}</b><br/>  */}
                        {/* {this.props.user.userEmail} */}
                    </Typography>

                    <IconButton onClick={()=>{this.props.signOut()}}>
                        <ExitToApp />
                        <Typography color='primary'>Sign Out</Typography>
                    </IconButton>
                    <a href="https://autozonetalent.training" target='_blank' rel='noreferrer'>
                        <LogoRender axl_only={true}/>
                    </a>
                </Grid>}

                
                

                {!this.props.signed_in&&
                <h3>Signing out...</h3>}

            </Paper>

        );
    }
}